import { createAction, props } from '@ngrx/store';
import { UserModels } from '@share-models';

export const startLoadRequiredData = createAction(
  '[AUTH] Start load required data',
);

export const requiredDataLoadedSuccess = createAction(
  '[AUTH] Required data loaded',
);

export const logout = createAction(
  '[AUTH] Logout',
  props<{ params: UserModels.LogoutParams }>(),
);

export const socialLoginByCode = createAction(
  '[AUTH] Social Login By Code',
  props<{ code: string }>(),
);
